import { useQuery } from '@tanstack/react-query';
import { fetchCatalogueSearchResultProducts } from './apiFetchCatalogueSearchResultProducts';
import { SearchSidebarResponseOut } from '../../../store/api';
import { Pagination } from '../../../../models/Pagination';
import { ProductFilter } from '../../../../models/Product';
import { browserClient } from '../../../react-query';

interface SearchResultParameterTypes {
    q?: string;
    scope: string;
    pagination: Pagination;
    filterMap: ProductFilter;
    loanFormat: string | null;
    refine?: string | null;
    shopLanguage: string | undefined;
}
const SEARCH_RESULT_PRODUCTS_QUERY = 'searchResultProducts';

export const useSearchResultProducts = (params: SearchResultParameterTypes) => {
    const { filterMap, pagination, loanFormat, q, scope, refine, shopLanguage } = params;
    const transformedFilterMap = JSON.stringify(filterMap);

    const { data, error, isLoading } = useQuery(
        [
            SEARCH_RESULT_PRODUCTS_QUERY,
            {
                filterMap: transformedFilterMap,
                ...pagination,
                loanFormat,
                q,
                scope,
                refine,
                shopLanguage
            }
        ],
        () =>
            fetchCatalogueSearchResultProducts({
                q,
                filterMap: transformedFilterMap,
                pagination,
                loanFormat,
                scope,
                refine: refine || null,
                shopLanguage
            })
    );

    const didYouMean: string | undefined = data?.didYouMean || undefined;
    const refinedSearchCategories: { [key: string]: string } = data?.refinedSearchCategories || {};
    const currentRefine: string | undefined = data?.currentRefine || undefined;
    const relatedResults: SearchSidebarResponseOut = data?.relatedResults || {};
    return {
        ...data,
        products: data?.hits ?? [],
        count: data?.totalHits ?? 0,
        didYouMean,
        refinedSearchCategories,
        currentRefine,
        relatedResults,
        error,
        isSearchResultsLoading: isLoading
    };
};

export function invalidateSearchResultProducts() {
    return browserClient.invalidateQueries({ queryKey: [SEARCH_RESULT_PRODUCTS_QUERY] });
}
